import { render, staticRenderFns } from "./OrderUserComponent.vue?vue&type=template&id=54513a72&scoped=true"
import script from "./OrderUserComponent.vue?vue&type=script&lang=js"
export * from "./OrderUserComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderUserComponent.vue?vue&type=style&index=0&id=54513a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54513a72",
  null
  
)

export default component.exports